import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MasterPagePublic from '../layouts/master-page-public';
import MasterPageAuth from '../layouts/master-page-auth';
import MasterPageAuthNoMenu from '../layouts/master-page-auth-no-menu';
import MasterPageAuthMessenger from '../layouts/master-page-auth-messenger';
import { publicRoutes, authRoutes, authNoMenuRoutes, messengerRoutes } from '../routes/route-name';

const RouteIndex = () => {
    return (
        <React.Fragment>
            <Routes>
                {/* Public — ไม่ต้อง login */}
                <Route element={<MasterPagePublic />}>
                    {publicRoutes.map((route, idx) => (
                        <Route key={idx} path={route.path} element={route.component} />
                    ))}
                </Route>

                {/* Auth No Menu — ต้อง login แต่ไม่มี sidebar */}
                <Route element={<MasterPageAuthNoMenu />}>
                    {authNoMenuRoutes.map((route, idx) => (
                        <Route key={idx} path={route.path} element={route.component} />
                    ))}
                </Route>

                {/* Auth — ต้อง login + menuData (User / Admin) */}
                <Route element={<MasterPageAuth />}>
                    {authRoutes.map((route, idx) => (
                        <Route key={idx} path={route.path} element={route.component} />
                    ))}
                </Route>

                {/* Messenger — เช็คแค่ token + user_group */}
                <Route element={<MasterPageAuthMessenger />}>
                    {messengerRoutes.map((route, idx) => (
                        <Route key={idx} path={route.path} element={route.component} />
                    ))}
                </Route>
            </Routes>
        </React.Fragment>
    );
};

export default RouteIndex;